import React,{useState} from "react";
import './CreateAccount.css';
import '../../../Common.css';
import { SendOTP,ResetPassword } from "../../../services/Api";

// components
import PrimarySolidButton from "../../Buttons/PrimarySolidButton/PrimarySolidButton";
import PopUpMainHeading from "../../Heading/PopUpMainHeading/PopUpMainHeading";
import AccountWarning from "../TextItems/AccountWarning/AccountWarning";
import PopUpSubHeading from "../../Heading/PopUpSubHeading/PopUpSubHeading";
import InputTextField from "../../InputFields/InputTextField/InputTextField";
import ScuccessPopUp from "../AccountCreationSuccess/ScuccessPopUp";
import PasswordInput from "../../InputFields/InputPasswordField/InputPasswordField";
import ErrorMessageAR from "../../ErrorMessage/ErrorMessageAR";
import SelectField from "../../InputFields/SelectField/SelectField";




const ForgotPasswordAR = ({ onClose, onInputChange, onSubmit,onComplete }) => {
    const [step, setStep] = useState(1); // Step to track the current stage (1: Mobile, 2: OTP, 3: Passwords)
    const [otpError, setOtpError] = useState(""); // To show OTP errors if any
    const [mobileError,setMobileError] = useState("");
    const options = [
        { value: "966", label: "+966 (Saudi)" }, 
        { value: "962", label: "+962 (Jordan)" }
    ];
    const [formData, setFormData] = useState({
        country_code:"966",
        mobile: "",
        otp: "",
        newPassword: "",
        confirmPassword: "",
    });

    const handleOverlayClick = (e) => {
        if (e.target.className === "login-popup-overlay") {
            onClose();
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      onInputChange(name, value); // Pass input data to parent component if needed
    };

    const handleSendOtp = async () => {
        if (!formData.mobile.trim()) {
            setMobileError("الرجاء إدخال رقم جوال صالح");
            // alert("Please enter a valid mobile number");
        return;
        }
        const body={
            "mobile":formData.mobile.trim(),
            "country_code":formData.country_code
        }
        try {
            const response = await SendOTP({ body });
            if (response.error){
                setMobileError("خطأ في إرسال OTP");
                // console.log("error sending otp")
                return;
            }
            else{
                if (response.data.resp_code === 1){
                    setStep(2);
                    setMobileError("");
                }
                else{
                    // setMobileError("حدث خطأ أثناء إرسال كلمة المرور لمرة واحدة (OTP). يرجى المحاولة مرة أخرى.");
                    setMobileError(response.data.message);
                }
            }
            
        } catch (error) {
            setMobileError("حدث خطأ ما. يرجى المحاولة مرة أخرى.");
        }
    };

    const handleResetAccount = async () => {
        const { newPassword, confirmPassword } = formData;
        if (!formData.otp.trim()) {
                setOtpError("الرجاء إدخال كلمة المرور لمرة واحدة.");
            return;
        }
        if(!newPassword.trim().length>0 | !confirmPassword.trim().length>0){
            setOtpError("لا يمكن أن تكون كلمات المرور فارغة.")
            return;
        }
        if (newPassword !== confirmPassword) {
            setOtpError("كلمات المرور غير متطابقة.")
            return;
        }
        const body = {
            "country_code":formData.country_code,
            "mobile":formData.mobile.trim(),
            "otp":formData.otp.trim(),
            "password":formData.newPassword.trim(),
            "confirm_password":formData.confirmPassword.trim()
        }
        
        try {
            const response = await ResetPassword({ body });
            if (response.error){
                setOtpError("كلمة مرور OTP غير متطابقة. يرجى المحاولة مرة أخرى.")
                return;
            }
            else{
                if (response.data.resp_code === 1){
                    setOtpError("")
                    onComplete();
                }
                else{
                    // setOtpError("كلمة مرور OTP غير متطابقة. يرجى المحاولة مرة أخرى.")
                    setOtpError(response.data.message);
                }
            }
            
        } catch (error) {
            console.error("Error verifying OTP:", error);
            setOtpError("حدث خطأ ما. يرجى المحاولة مرة أخرى.");
        }
    };


    // const handleResetPassword = async () => {
    //     const { newPassword, confirmPassword } = formData;
    //     if (newPassword !== confirmPassword) {
    //     alert("Passwords do not match!");
    //     return;
    //     }
    //     try {
    //         const response = await onSubmit({
    //             mobile: formData.mobile,
    //             newPassword: formData.newPassword,
    //         });
    //         if (response.success) {
    //             alert("Password reset successfully!");
    //             onClose(); // Close the popup
    //         } else {
    //             alert("Error resetting password. Please try again.");
    //         }
    //     } catch (error) {
    //         console.error("Error resetting password:", error);
    //     }
    // };

    return (
    <div className="login-popup-overlay" onClick={handleOverlayClick}>
        <div className="register-pop-up">
            <div className="register-head-section">
            <PopUpMainHeading content={"إعادة تعيين كلمة مرور حسابك"} />
            <PopUpSubHeading
                content={
                step === 1
                    ? "أدخل رقم هاتفك المحمول المسجل لتلقي كلمة مرور لمرة واحدة (OTP)."
                    : "أدخل بيانات الاعتماد التالية لإعادة ضبط حسابك."
                    // ? "Enter the OTP sent to your registered mobile number."
                    // : "Set your new password."
                }
            />
        </div>
        <form className="login-input-button-section">
        {otpError && <ErrorMessageAR message={otpError}/>}
            {step === 1 && (
            <div className="input-field-section">
                <div className="mobile-with-code gap-62 arabic-flex">
                    <SelectField htmlFor={"coutrycode"} content={'رمز البلد'} 
                        required={true} options={options}
                        onChange={handleChange}
                        dvalue={formData.country_code}
                        isArabic={true}
                        name={"country_code"}

                    />

                    <InputTextField
                        htmlFor={"mobile"}
                        content={"الجوال المسجل"}
                        name={"mobile"}
                        value={formData.mobile}
                        onChange={handleChange}
                        isArabic={true} dir="rtl"
                        type="mobile"
                    />
                </div>
                {/* <InputTextField
                    htmlFor={"mobile"}
                    content={"الجوال المسجل"}
                    name={"mobile"}
                    value={formData.mobile}
                    onChange={handleChange}
                    isArabic={true} dir="rtl"
                    type="mobile"
                /> */}
                {mobileError && <ErrorMessageAR message={mobileError}/>}
                <div className="button-padding"></div>
                <PrimarySolidButton label={"أرسل كلمة مرور لمرة واحدة"} onClick={handleSendOtp} />
            </div>
            )}
            {step === 2 && (
            <div className="input-field-section">
                {/* {otpError && <p className="error-message">{otpError}</p>} */}
                <InputTextField
                    htmlFor={"otp"}
                    content={"أدخل كلمة المرور لمرة واحدة"}
                    name={"otp"}
                    value={formData.otp}
                    onChange={handleChange}
                    isArabic={true} dir="rtl"
                />
                <PasswordInput
                    htmlFor={"newPassword"}
                    content={"كلمة المرور الجديدة"}
                    name={"newPassword"}
                    value={formData.newPassword}
                    onChange={handleChange}
                    type="password"
                    isArabic={true} dir="rtl"
                    hasPhoneIcon = {false}
                />
                <PasswordInput
                    htmlFor={"confirmPassword"}
                    content={"تأكيد كلمة المرور"}
                    name={"confirmPassword"}
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    type="password"
                    isArabic={true} dir="rtl"
                    hasPhoneIcon = {false}
                />
                <div className="button-padding"></div>
                <PrimarySolidButton label={"يُقدِّم"} onClick={handleResetAccount} />
            </div>
            )}
        </form>
        </div>
    </div>
    );
};

export default ForgotPasswordAR;
